import {until} from 'lit-html/directives/until';
import {repeat} from 'lit-html/directives/repeat';
import {licenseActions, dynamicPages} from '../constants-enumerate';
import '../ems-collapse';
import '../pagination-element';
import{LoadingEllipses} from '@epg/epg-components';

export default (ctx, html) => {
  let content;
  if (ctx.loading) {
    content = html`
      <div class="d-flex m-5 p-5 justify-content-center">
        <loading-ellipses></loading-ellipses>
      </div>
    `;
  } else if (ctx.data.results.length > 0) {
    content = html`${repeat(ctx.data.results, (item) => item.id, (item) => renderLog(ctx, html, item))}`;
  } else {
    content = html`<div class="text-center text-muted p-5 m-5">${until(ctx.__('<tt-gbh7VAaB>', 'No inventory history.'))}</div>`;
  }

  let pagination = '';
  if (!ctx['hide-pagination']) {
    pagination = html`
      <pagination-element @page-change="${ctx.pageChanged}" num-pages=${ctx.pages} current-page=${ctx.currentPage} disable-pages>
        <span slot="prev-label">${until(ctx.__('<tt-7FD5IXp5>', 'Prev'))}</span>
        <span slot="next-label">${until(ctx.__('<tt-jXfrt/aF>', 'Next'))}</span>
      </pagination-element>
    `;
  }

  return html`
    <div class="mb-3">
      ${content}
    </div>
    <div class="mx-auto text-center ${ctx.loading ? 'd-none' : ''}">
      ${pagination}
    </div>
  `;
};

const renderEventInfo = (ctx, html, item) => html`
  <span class="text-muted">${until(ctx.__('<tt-g6ljK0CL>', 'Event'))}</span>
  <span>${until(ctx.licenseTranslations[item.event_type])}</span>
`;

const renderLog = (ctx, html, item) => {
  let content;
  if (ctx['for-student-view']) {
    content = html`${renderEventInfo(ctx, html, item)}`;
  } else {
    content = html`
      <span class="text-muted">${until(ctx.__('<tt-8yERlpnb>', 'Number Of Licenses'))}</span>
      <span>${renderQuantity(ctx, html, item)}</span>
    `;
  }

  return html`
    <collapse-button
      role="button"
      id="license-${item.license_id}"
      @open-change="${(e) => ctx.toggleOpen(item.license_id)}"
      tabIndex="0"
      controls="(ungrouped, dist-${item.id})" class="w-100 px-3 pt-3 pb-0 pb-xs-3"
      aria-expanded="${ctx.openLicenseIds[item.license_id]}"
    >
      <div class="">
        <div class="row">
          <div class="col-12 col-sm-4 pb-2 pb-xs-0 d-flex align-items-center">
            <div>
              <span class="ai ai-chevron-down h2"></span>
              <span class="h4 pl-2">${item.$date}</span>
            </div>
          </div>
          <div class="col-12 col-sm-5 pb-2 pb-xs-0">
            <div class="d-flex flex-column" style="min-width: 0;">
              <span class="text-muted">${until(ctx.__('<tt-lFM9E3T5>', 'License Name'))}</span>
              ${item.license_id ? html`<link-to class="text-underline text-truncate" href="${dynamicPages.licenseDetails(item.license_id)}" aria-title="${item.license_name}">${item.license_name}</link-to>` : html`<span>${item.license_name}</span>`}
            </div>
          </div>
          <div class="col-12 col-sm-3 pb-2 pb-xs-0">
            <div class="d-flex flex-column">
              ${content}
            </div>
          </div>
        </div>
      </div>
    </collapse-button>
    <ems-collapse group="ungrouped" id="dist-${item.id}" class="px-3 pb-3 pt-0 pt-xs-3 border-bottom">
      <div class="row">
        <div class="col-12 col-sm-4 pb-2 pb-xs-0">
          <div class="d-flex flex-column">
            <span class="text-muted">${until(ctx.__('<tt-4Q70PChg>', 'Updated By (From)'))}</span>
            <span>${item.user_name} ${item.from_group_name ? '(' + item.from_group_name + ')' : ''}</span>
          </div>
        </div>
        <div class="col-12 col-sm-5 pb-2 pb-xs-0">
          <div class="d-flex flex-column">
            <span class="text-muted">${until(ctx.__('<tt-sENaGZv6>', 'To'))}</span>
            <span>${(item.to_group_name) ? item.to_group_name : until(ctx.licenseTranslations.Students)}</span>
          </div>
        </div>
        <div class="col-12 col-sm-3 pb-2 pb-xs-0">
          <div class="d-flex flex-column">
            ${ctx['for-student-view'] ? `` : html`${renderEventInfo(ctx, html, item)}`}
          </div>
        </div>
      </div>
    </ems-collapse>
  `;
};

const renderQuantity = (ctx, html, item) => {
  let className = 'text-danger';
  // This is for a student
  const positiveActions = [licenseActions.LICENSE_CREATED, licenseActions.LICENSE_REVOKED];

  if (
    (item.to_group_id && item.to_group_id === ctx.groupId) ||
    (item.to_group_id && Object.keys(ctx.filters).length === 0 && item.to_group_id === ctx.groupId) ||
    (typeof item.to_student_id !== 'undefined' && item.type === licenseActions.LICENSE_TRANSFERRED) ||
    positiveActions.includes(item.type)
  ) {
    className = 'text-success';
  }

  let quantity = item.quantity;
  if (typeof item.to_student_id !== 'undefined' && item.event_type !== licenseActions.LICENSE_EXTENDED) {
    // have to set quantity if the license is assigned to a student, since
    // quantity is not reported in the allocation_log
    quantity = 1;
  } else if (
    (!item.to_group_id && item.type === licenseActions.LICENSE_TRANSFERRED) ||
    item.event_type === licenseActions.LICENSE_EXTENDED
  ) {
    // if a license is transferred from one student to another
    quantity = 0;
  }

  // This is what happens when the student profile allocation logs are
  // using this component
  return html`
    <span class="${className}">
      ${className === 'text-success' ? '+' : '-'}${quantity}
    </span>`;
};
